import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import Logo from './../../Assets/Images/logo-02.png'
import { SEND_PASSWORD_TO_EMAIL } from '../../graphql/Catalog/Users/user'
import MigrantsHeader from '../DashboardMigrants/components/MigrantsHeader'
import MigrantsFooter from '../DashboardMigrants/components/MigrantsFooter'

export const RecoveryPassword = () => {
  const [form, setForm] = useState({
    email: '',
  })
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [sendPasswordToEmail] = useMutation(SEND_PASSWORD_TO_EMAIL)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (form.email === '')
      return toastSweetAlert({
        mode: 'error',
        message: 'Ingrese su correo electrónico',
      })

    setLoading(true)
    try {
      await sendPasswordToEmail({
        variables: {
          email: form.email,
        },
      })
      setLoading(false)
      return toastSweetAlert(
        {
          mode: 'okModal',
          message: 'Se ha enviado tu nueva contraseña en el correo',
        },
        history.push('/login')
      )
    } catch (error) {
      setLoading(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  return (
    <div className="recovery-container row">
      <div className="col-12">
        <MigrantsHeader showContact={false} />
      </div>
      <div className="full-container recovery-box col-12">
        <div className="row mb-5 mt-4 text-center">
          {/* <div className="col-12 image-box">
            <img src={Logo} className="img-logo-full m-4" alt="logo" />
          </div> */}
          <h5 className="title-migrates">Recuperar contraseña</h5>
          <span className="text-migrates">
            Ingrese su correo electrónica para mandar un codigo para resetear su
            contraseña
          </span>
        </div>
        <div className="full-box row">
          <div className="col-12 p-3">
            <form onSubmit={handleSubmit} method="post" className="row">
              <label htmlFor="user" className='text-migrates'>Email</label>
              <div className="input-icons-login col-12 iconInside">
                <i className="far fa-user"></i>
                <input
                  id="user"
                  type="text"
                  className="form-control"
                  placeholder="Ingrese su correo electrónico"
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                />
              </div>
              <div className="login-btn col-12">
                {loading ? (
                  <button
                    className="btn btn-recovery btn-sm"
                    type="button"
                    disabled
                  >
                    <span
                      className="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Procesando...</span>
                  </button>
                ) : (
                  <div className="actions-box">
                    <button type="submit" className="btn btn-migrates btn-sm">
                      Enviar
                    </button>
                    <Link to="/login" className="btn btn-migrates-white mt-2">
                      Regresar
                    </Link>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="col-12">
        <MigrantsFooter showContact={false} showChatbot={false} />
      </div>
    </div>
  )
}

export default RecoveryPassword
